import React, { useState, useEffect } from "react";
import styled from "styled-components";

const WaterStatsContainer = styled.div`
  margin: 0.5rem 0;
  padding: 0.5rem 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
`;

const WaterStatsTitle = styled.h4`
  font-size: 16px;
  margin-bottom: 0.5rem;
  color: #374151;
`;

const WaterStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
`;

const WaterStatItem = styled.div`
  text-align: center;
  padding: 0.5rem;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
`;

const WaterStatLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 0.25rem;
`;

const WaterStatValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

const WaterInnerStatsBar = ({ waterInM3PerTon, t }) => {
  const [greenInPercent,setGreenInPercent] = useState(0);
  const [blueInPercent,setBlueInPercent] = useState(0);
  const [greyInPercent,setGreyInPercent] = useState(0);

  useEffect(() => {
    console.log("waterInM3PerTon", waterInM3PerTon);
    
    // Handle both direct data and nested data structure
    const waterData = waterInM3PerTon?.water_in_m3ton || waterInM3PerTon;
    
    if (waterData && waterData.total && waterData.total > 0) {
      const greenPercent = Math.round((waterData.green / waterData.total) * 100);
      const bluePercent = Math.round((waterData.blue / waterData.total) * 100);
      const grayPercent = Math.round((waterData.gray / waterData.total) * 100);
      
      console.log("Calculated percentages:", { greenPercent, bluePercent, grayPercent });
      
      setGreenInPercent(greenPercent);
      setBlueInPercent(bluePercent);
      setGreyInPercent(grayPercent);
    }
  }, [waterInM3PerTon]);
 
  return (
    <WaterStatsContainer>
      <WaterStatsTitle>{t("Vattenfotavtryck detaljer")}</WaterStatsTitle>
      <WaterStatsGrid>
        <WaterStatItem>
          <WaterStatLabel style={{ color: '#4ade80' }}>{t("Grönt")}</WaterStatLabel>
          <WaterStatValue>{greenInPercent || 0}%</WaterStatValue>
        </WaterStatItem>
        <WaterStatItem>
          <WaterStatLabel style={{ color: '#3b82f6' }}>{t("Blått")}</WaterStatLabel>
          <WaterStatValue>{blueInPercent || 0}%</WaterStatValue>
        </WaterStatItem>
        <WaterStatItem>
          <WaterStatLabel style={{ color: '#6b7280' }}>{t("Grått")}</WaterStatLabel>
          <WaterStatValue>{greyInPercent || 0}%</WaterStatValue>
        </WaterStatItem>
        <WaterStatItem>
          <WaterStatLabel>{t("Total")}</WaterStatLabel>
          <WaterStatValue>{(waterInM3PerTon?.water_in_m3ton?.total || waterInM3PerTon?.total || 0).toLocaleString('sv-SE')} {t("liter")} H₂O</WaterStatValue>
        </WaterStatItem>
      </WaterStatsGrid>
    </WaterStatsContainer>
  );
};

export default WaterInnerStatsBar;
